import { render, staticRenderFns } from "./upload-cover-note.vue?vue&type=template&id=0c127104&scoped=true&"
import script from "./upload-cover-note.vue?vue&type=script&lang=js&"
export * from "./upload-cover-note.vue?vue&type=script&lang=js&"
import style0 from "./upload-cover-note.vue?vue&type=style&index=0&id=0c127104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c127104",
  null
  
)

export default component.exports